/**
 * Choix de la langue d'affichage.
 *
 * Deux langues seulement : un menu déroulant serait plus lourd que le choix
 * qu'il porte. Le réglage est gardé par i18next dans localStorage, donc il
 * survit au rechargement sans que rien ne transite par le serveur.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUES } from '../i18n';

const SelecteurLangue = () => {
  const { i18n, t } = useTranslation();
  const courante = (i18n.resolvedLanguage || i18n.language || 'en').slice(0, 2);

  return (
    <div
      className="flex items-center gap-0.5 bg-dark-800 rounded-lg p-0.5"
      role="group"
      aria-label={t('langue.libelle')}
    >
      {LANGUES.map(({ code, libelle }) => {
        const active = code === courante;
        return (
          <button
            key={code}
            type="button"
            onClick={() => i18n.changeLanguage(code)}
            aria-pressed={active}
            title={libelle}
            className={`px-2 py-1 rounded text-xs font-medium uppercase transition-colors ${
              active
                ? 'bg-dark-700 text-dark-100'
                : 'text-dark-500 hover:text-dark-300'
            }`}
          >
            {code}
          </button>
        );
      })}
    </div>
  );
};

export default SelecteurLangue;
